// src/components/App/App.js

import React, { PureComponent } from "react";
import { withRouter } from "react-router-dom";
import Sticky from "react-stickynode";
import { isMobileOnly } from "react-device-detect";
import AppBar from "./AppBar";
import NavBar from "./NavBar";
import AppBarNoAccess from "./AppBarNoAccess";
import AppBarOther from "./AppBarOther";

class App extends PureComponent {
  constructor(props) {
    super(props);

    let isFP = false;
    if (window.isFP) {
      isFP = window.isFP;
    }

    let isLoggedIn = false;
    if (
      window.portfolioMapper &&
      window.portfolioMapper.token &&
      window.portfolioMapper.token !== ""
    ) {
      isLoggedIn = true;
    }

    let toolsToShow = [
      "my-portfolio-hub",
      "model-performance",
      "portfolio-analysis",
      "custom-models",
      "fund-comparison",
      "capital-gains-comparison",
      "fund-attribution",
      "index-attribution",
      "performance-at-a-glance",
      "morningstar-ratings",
      "fibb",
      "earnings",
      "chartaday",
    ];
    if (window.dpdplat && window.dpdplat.toolsToShow) {
      toolsToShow = window.dpdplat.toolsToShow;
    }
    toolsToShow = this.normalizeToolsToShow(toolsToShow);

    let resourcesToShow = [
      "dashboard",
      "dashboard",
      "barbell",
      "yield",
      "fundlist",
      "models",
      "befi",
      "taxport",
    ];
    if (window.dpdplat && window.dpdplat.resourcesToShow) {
      resourcesToShow = window.dpdplat.resourcesToShow;
    }

    this.state = {
      isFP: isFP,
      isLoggedIn: isLoggedIn,
      toolsToShow: toolsToShow,
      resourcesToShow: resourcesToShow,
      activeApp: "",
    };

    this.handleLoad = this.handleLoad.bind(this);
  }

  normalizeToolsToShow = (tools) => {
    const aliases = {
      models: "model-performance",
      modelportfolios: "model-performance",
      modelperformance: "model-performance",
    };
    const seen = new Set();
    return tools
      .map((tool) => aliases[tool] || tool)
      .filter((tool) => {
        if (seen.has(tool)) return false;
        seen.add(tool);
        return true;
      });
  };

  componentDidMount() {
    let { history } = this.props;

    window.addEventListener("load", this.handleLoad);

    history.listen(() => {
      const hash = history.location.hash.substring(1).split("&")[0];
      this.activateApp(hash);
    });
  }

  componentWillUnmount() {
    window.removeEventListener("load", this.handleLoad);
  }

  handleLoad() {
    const hash = window.location.hash.substring(1).split("&")[0];
    if (hash !== "" && hash !== "toolscenter") {
      this.activateApp(hash);
    }
  }

  selectApp = (appName) => {
    let { activeApp } = this.state;

    const modelPortfolioUrl =
      "https://www.wisdomtree.com/investments/mac/model-portfolios";
    if (appName === "model-performance") {
      window.open(modelPortfolioUrl, "_blank", "noopener,noreferrer");
      return;
    }

    let newApp = activeApp === appName ? "" : appName;
    window.location = "#" + newApp + "&";
  };

  convertAppName = (name) => {
    switch (name) {
      case "myportfolios":
        return "my-portfolio-hub";
      case "modelperformance":
        return "model-performance";
      case "modelportfolios":
      case "models":
        return "model-performance";
      case "dpd":
        return "portfolio-analysis";
      case "custom-models":
        return "custom-models";
      case "fundchar":
        return "fund-comparison";
      case "capgains":
        return "capital-gains-comparison";
      case "mstar":
        return "morningstar-ratings";
      case "fibb":
        return "fibb";
      case "topperf":
        return "performance-at-a-glance";
      case "perfattr":
        return "index-attribution";
      case "fundattr":
        return "fund-attribution";
      default:
        return name;
    }
  };

  getAppNameforGA(name) {
    switch (name) {
      case "my-portfolio-hub":
        return "my portfolio hub";
      case "portfolio-analysis":
        return "portfolio analysis";
      case "custom-models":
        return "custom models";
      case "fund-comparison":
        return "fund comparison";
      case "capital-gains-comparison":
        return "capital gains";
      case "morningstar-ratings":
        return "morningstar ratings";
      case "fibb":
        return "fibb";
      case "performance-at-a-glance":
        return "performance at a glance";
      case "index-attribution":
        return "index attribution";
      case "fund-attribution":
        return "fund attribution";
      case "earnings":
        return "earnings";
      case "chartaday":
        return "chartaday";
      default:
        return "";
    }
  }

  saveToGA(name) {
    name = this.getAppNameforGA(name);
    const e = {
      eventName: name,
      eventAction: "opened",
      eventLabel: "",
      type: "CustomTagEvent",
    };

    if (window.digitalData) {
      window.digitalData.newEvent(e);
      console.log("Window digitalData: ", e);
    } else {
      console.log("Window No digitalData: ", e);
    }
  }

  activateApp = (activeApp) => {
    const { isFP, toolsToShow } = this.state;

    // convert the app name to current naming
    activeApp = this.convertAppName(activeApp);

    // filter out non FP if trying to get to FP app
    const gpApps = [
      "",
      "fund-comparison",
      "index-attribution",
      "fund-attribution",
      "performance-at-a-glance",
      "morningstar-ratings",
      "fibb",
      "earnings",
      "chartaday",
    ];
    if (
      toolsToShow.includes(activeApp) &&
      !isFP &&
      !gpApps.includes(activeApp)
    ) {
      window.location.href = "/restricted-material";
    }

    // scroll to toolscenter and activate appropriate app
    let nav = document.getElementById("toolscenter");
    if (nav) {
      nav.scrollIntoView({ top: 0, behavior: "smooth" });
    }

    if (
      (activeApp === "" || toolsToShow.includes(activeApp)) &&
      activeApp !== "toolscenter"
    ) {
      this.updateActiveApp(activeApp);
    }
    // fire off GA event
    this.saveToGA(activeApp);
  };

  updateActiveApp = (activeApp) => {
    this.setState({
      activeApp: activeApp,
    });
  };

  render() {
    const { isFP, isLoggedIn, toolsToShow, resourcesToShow, activeApp } =
      this.state;
    console.log("Active App: ", activeApp);
    console.log("Tools to Show: ", toolsToShow);
    const onDashboard =
      window.location.href.indexOf("dashboard") > -1 ? true : false;
    return (
      <div>
        <div className="container-fluid" style={{ backgroundColor: "#FFF" }}>
          <div id="toolscenter" />
          <Sticky innerZ={100} enabled={!isMobileOnly} top={0}>
            <NavBar
              isFP={isFP}
              activeApp={activeApp}
              selectCallback={this.selectApp}
              toolsToShow={toolsToShow}
            />
          </Sticky>
          {activeApp === "" && resourcesToShow.length > 0 && (
            <div className="row" style={{ backgroundColor: "#FFF" }}>
              <div
                className="col-sm-12"
                style={{
                  fontSize: "28px",
                  fontWeight: "300",
                  marginTop: "30px",
                  marginLeft: "20px",
                }}
              >
                MACRO TOOLS
              </div>
            </div>
          )}

          {toolsToShow.includes("chartaday") && (
            <AppBar
              title="Daily Charts"
              description="Daily charts picked by our thought leaders to help investors stay ahead of the curve on the markets."
              name="chartaday"
              divId="chartaday"
              activeApp={activeApp}
              selectCallback={this.selectApp}
              isLoggedIn={isLoggedIn}
              isFP={isFP}
            />
          )}

          {activeApp === "" && resourcesToShow.length > 0 && (
            <div className="row" style={{ backgroundColor: "#FFF" }}>
              <div
                className="col-sm-12"
                style={{
                  fontSize: "28px",
                  fontWeight: "300",
                  marginTop: "30px",
                  marginLeft: "20px",
                }}
              >
                INVESTMENT TOOLS
              </div>
            </div>
          )}
          {/* <div className='row' style={{ backgroundColor: '#FFF' }}>
          <div id='toolscenter' />
          <Sticky innerZ={100} enabled={!isMobileOnly} top={0}>
            <NavBar
              isFP={isFP}
              activeApp={activeApp}
              selectCallback={this.selectApp}
              toolsToShow={toolsToShow}
            />
          </Sticky> */}
          {toolsToShow.includes("fund-comparison") && (
            <AppBar
              title="Fund Comparison"
              description="Compare funds and benchmark indexes based on fundamental characteristics, exposures, performance and more."
              name="fund-comparison"
              divId="fundchar"
              activeApp={activeApp}
              selectCallback={this.selectApp}
              isLoggedIn={isLoggedIn}
              isFP={isFP}
            />
          )}
          {isLoggedIn && isFP && toolsToShow.includes("model-performance") && (
            <AppBar
              title="Model Portfolios"
              description="View our full suite of model portfolios, including performance, allocations, and exposures."
              name="model-performance"
              divId="modelperformance"
              activeApp={activeApp}
              selectCallback={this.selectApp}
            />
          )}
          {isLoggedIn && isFP && toolsToShow.includes("my-portfolio-hub") && (
            <AppBar
              title="My Portfolio Hub"
              description="Manage your custom portfolio strategies, track performance, and integrate with the full suite of tools."
              name="my-portfolio-hub"
              divId="myportfolios"
              activeApp={activeApp}
              selectCallback={this.selectApp}
            />
          )}
          {isLoggedIn && isFP && toolsToShow.includes("portfolio-analysis") && (
            <AppBar
              title="Portfolio Analysis"
              description="Analyze portfolios, stress test against a variety of market scenarios, and identify opportunities to improve outcomes."
              name="portfolio-analysis"
              divId="dpd"
              activeApp={activeApp}
              selectCallback={this.selectApp}
            />
          )}
          {isLoggedIn && isFP && toolsToShow.includes("custom-models") && (
            <AppBar
              title="Custom Model Portfolio Builder"
              description="Create a custom model portfolio using WisdomTree's asset allocation guidance tailored to your clients' goals and risk tolerance."
              name="custom-models"
              divId="modelcustomization"
              activeApp={activeApp}
              selectCallback={this.selectApp}
            />
          )}

          {isLoggedIn &&
            isFP &&
            toolsToShow.includes("capital-gains-comparison") && (
              <AppBar
                title="Capital Gains and Tax Analysis"
                description="Looking to potentially optimize your portfolio for tax loss harvesting? Search thousands of estimates from leading asset managers."
                name="capital-gains-comparison"
                divId="portfolioMapper"
                activeApp={activeApp}
                selectCallback={this.selectApp}
              />
            )}
          {toolsToShow.includes("fund-attribution") && (
            <AppBar
              title="Fund Attribution"
              description="See key performance attributions that set our funds apart from broad market competitors."
              name="fund-attribution"
              divId="fundattr"
              activeApp={activeApp}
              selectCallback={this.selectApp}
            />
          )}
          {toolsToShow.includes("index-attribution") && (
            <AppBar
              title="Index Attribution"
              description="See key performance attributions that set our methodology apart from broad market benchmarks."
              name="index-attribution"
              divId="perfattr"
              activeApp={activeApp}
              selectCallback={this.selectApp}
            />
          )}
          {toolsToShow.includes("performance-at-a-glance") && (
            <AppBar
              title="Performance at a Glance"
              description="Identify short- and long-term trends in the market using WisdomTree top and bottom performing ETFs as a lens."
              name="performance-at-a-glance"
              divId="topperf"
              activeApp={activeApp}
              selectCallback={this.selectApp}
            />
          )}
          {toolsToShow.includes("morningstar-ratings") && (
            <AppBar
              title="Morningstar Ratings"
              description="View all WisdomTree 4- and 5-star rated Funds based on risk-adjusted returns."
              name="morningstar-ratings"
              divId="morningStarApp"
              activeApp={activeApp}
              selectCallback={this.selectApp}
            />
          )}
          {toolsToShow.includes("fibb") && (
            <AppBar
              title="Fixed Income Barbell"
              description="Explore enhanced yield using our interactive Barbell."
              name="fibb"
              divId="fibb"
              activeApp={activeApp}
              selectCallback={this.selectApp}
            />
          )}
          {toolsToShow.includes("earnings") && (
            <AppBar
              title="Earnings Path"
              description="Sector level snapshot of year-over-year earnings growth and earnings surprise for constituents of select indexes."
              name="earnings"
              divId="earningsapp"
              activeApp={activeApp}
              selectCallback={this.selectApp}
            />
          )}

          <div className="clearfix" />
        </div>
        <div className="container-fluid" style={{ backgroundColor: "#FFF" }}>
          {!isLoggedIn &&
            activeApp === "" &&
            (toolsToShow.includes("my-portfolio-hub") ||
              toolsToShow.includes("model-performance") ||
              toolsToShow.includes("portfolio-analysis") ||
              toolsToShow.includes("custom-models") ||
              toolsToShow.includes("capital-gains-comparison")) && (
              <div className="row">
                <div
                  className="col-sm-12"
                  style={{
                    fontSize: "28px",
                    fontWeight: "300",
                    marginTop: "60px",
                  }}
                >
                  ADDITIONAL TOOLS FOR FINANCIAL PROFESSIONALS
                </div>
              </div>
            )}
          <div className="row">
            {!isLoggedIn &&
              activeApp === "" &&
              toolsToShow.includes("my-portfolio-hub") && (
                <AppBarNoAccess
                  title="My Portfolio Hub"
                  description="Manage your custom portfolio strategies, track performance, and integrate with the full suite of tools."
                  name="my-portfolio-hub"
                  divId="myportfolios"
                  activeApp={activeApp}
                  link="/investments/tools#my-portfolio-hub&"
                  message="Financial Professional Access Only"
                />
              )}
            {!isLoggedIn &&
              activeApp === "" &&
              toolsToShow.includes("models") && (
                <AppBarNoAccess
                  title="Model Portfolios"
                  description="'View our full suite of model portfolios, including performance, allocations, and exposures."
                  name="models"
                  divId="models"
                  activeApp={activeApp}
                  link="/investments/tools#models&"
                  message="Financial Professional Access Only"
                />
              )}
            {/* {!isLoggedIn &&
              activeApp === "" &&
              toolsToShow.includes("model-performance") && (
                <AppBarNoAccess
                  title="Model Performance"
                  description="Track WisdomTree strategies, track performance, and integrate with the full suite of tools."
                  name="model-performance"
                  divId="modelperformance"
                  activeApp={activeApp}
                  link="/investments/tools#model-performance&"
                  message="Financial Professional Access Only"
                />
              )} */}
            {!isLoggedIn &&
              activeApp === "" &&
              toolsToShow.includes("portfolio-analysis") && (
                <AppBarNoAccess
                  title="Portfolio Analysis"
                  description="Analyze portfolios, stress test against a variety of market scenarios, and identify opportunities to improve outcomes."
                  name="portfolio-analysis"
                  divId="dpd"
                  activeApp={activeApp}
                  link="/investments/tools#portfolio-analysis&"
                  message="Financial Professional Access Only"
                />
              )}
            {!isLoggedIn &&
              activeApp === "" &&
              toolsToShow.includes("custom-models") && (
                <AppBarNoAccess
                  title="Custom Model Portfolio Builder"
                  description="Create your own custom model from a WisdomTree Portfolio."
                  name="custom-models"
                  divId="modelFization"
                  activeApp={activeApp}
                  link="/investments/tools#custom-models&"
                  message="Financial Professional Access Only"
                />
              )}
            {!isLoggedIn &&
              activeApp === "" &&
              toolsToShow.includes("capital-gains-comparison") && (
                <AppBarNoAccess
                  title="Capital Gains and Tax Analysis"
                  description="Looking to potentially optimize your portfolio for tax loss harvesting? Search thousands of estimates from leading asset managers."
                  name="capital-gains-comparison"
                  divId="portfolioMapper"
                  activeApp={activeApp}
                  link="/investments/tools#capital-gains-comparison&"
                  message="Financial Professional Access Only"
                />
              )}
          </div>
        </div>
        <div className="container-fluid" style={{ backgroundColor: "#FFF" }}>
          {activeApp === "" && resourcesToShow.length > 0 && (
            <div className="row">
              <div
                className="col-sm-12"
                style={{
                  fontSize: "28px",
                  fontWeight: "300",
                  marginTop: "60px",
                }}
              >
                MORE RESOURCES
              </div>
            </div>
          )}
          <div className="row"></div>
          <div className="row" style={{ backgroundColor: "#FFF" }}>
            {isLoggedIn &&
              isFP &&
              !onDashboard &&
              activeApp === "" &&
              resourcesToShow.includes("dashboard") && (
                <AppBarOther
                  title="My Dashboard"
                  description="Access the tools, technology, resources and support you need to take yourself, your team and your business to the next level."
                  name="dashboard"
                  activeApp={activeApp}
                  link="https://www.wisdomtree.com/investments/dashboard"
                />
              )}
            {isLoggedIn &&
              !isFP &&
              !onDashboard &&
              activeApp === "" &&
              resourcesToShow.includes("dashboard") && (
                <AppBarOther
                  title="My Dashboard"
                  description="Get access to timely insights, analysis and cutting-edge tools at your fingertips."
                  name="dashboard"
                  activeApp={activeApp}
                  link="https://www.wisdomtree.com/investments/dashboard"
                />
              )}
            {!isLoggedIn &&
              !onDashboard &&
              activeApp === "" &&
              resourcesToShow.includes("dashboard") && (
                <AppBarNoAccess
                  placement="moreResources"
                  title="My Dashboard"
                  description="Get access to timely insights, analysis and cutting-edge tools at your fingertips."
                  name="dashboard"
                  activeApp={activeApp}
                  link="https://www.wisdomtree.com/investments/dashboard"
                  message="Visit My Dashboard"
                />
              )}
            {activeApp === "" && resourcesToShow.includes("fundlist") && (
              <AppBarOther
                title="Fund Screener"
                description="Find out which funds suit your portfolio best by categorizing and filtering on key details."
                name="fundlist"
                activeApp={activeApp}
                link="https://www.wisdomtree.com/investments/etfs"
              />
            )}
            {activeApp === "" && resourcesToShow.includes("yield") && (
              <AppBarOther
                title="Dividend Yield Analysis"
                description="Review fund yields from a variety of perspectives."
                name="yield"
                activeApp={activeApp}
                link="https://www.wisdomtree.com/investments/etfs/all-pages/dividend-yield-analysis"
              />
            )}
            {!isLoggedIn &&
              activeApp === "" &&
              resourcesToShow.includes("models") &&
              !toolsToShow.includes("models") && (
                <AppBarNoAccess
                  placement="moreResources"
                  title="Model Portfolios"
                  description="View our full suite of model portfolios, including performance, allocations, and exposures."
                  name="models"
                  activeApp={activeApp}
                  link="https://www.wisdomtree.com/investments/mac/model-portfolios"
                />
              )}
            {/* {isLoggedIn && isFP && activeApp === '' && resourcesToShow.includes('befi') && <AppBarOther title='Behavioral Finance' description="Personalize your client's investment portfolio based on their individual behavioral differences." name='befi' activeApp={activeApp} link='https://www.wisdomtree.com/investments/mac/portfolio-impact' />} */}
            {/* {!isLoggedIn && activeApp === '' && resourcesToShow.includes('befi') && <AppBarNoAccess placement='moreResources' title='Behavioral Finance' description="Personalize your client's investment portfolio based on their individual behavioral differences." name='befi' activeApp={activeApp} link='https://www.wisdomtree.com/investments/mac/portfolio-impact' />} */}
            {isLoggedIn &&
              activeApp === "" &&
              isFP &&
              resourcesToShow.includes("taxport") && (
                <AppBarOther
                  title="Tax-Smart Model Portfolios"
                  description="Transition client portfolios to WisdomTree Model Portfolios through an automated tax managed approach."
                  name="taxport"
                  activeApp={activeApp}
                  link="https://www.wisdomtree.com/investments/55ip"
                />
              )}
            {!isLoggedIn &&
              activeApp === "" &&
              resourcesToShow.includes("taxport") && (
                <AppBarNoAccess
                  placement="moreResources"
                  title="Tax-Smart Model Portfolios"
                  description="Transition client portfolios to WisdomTree Model Portfolios through an automated tax managed approach."
                  name="taxport"
                  activeApp={activeApp}
                  link="https://www.wisdomtree.com/investments/55ip"
                />
              )}
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(App);



// WEBPACK FOOTER //
// ./src/components/App/App.js